<template>
  <a href="https://www.hire-a-home-advisor">
    <div class="home-advisor-banner">
      <img
        src="@/assets/images/phone-icon.png"
        name="home-advisor-phone-icon"
        id="home-advisor-phone-icon"
        text="home-advisor-phone-icon"
      />
      <p
        name="home-advisor-text"
        id="home-advisor-text"
        text="home-advisor-text"
      >Need help installing your doorbell? <strong>Tap here to hire a Home Advisor tech</strong></p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'HomeAdvisorBanner'
}
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

.home-advisor-banner {
  width: 100%;
  display: flex;
  align-items: center;
  background: orange;
  color: #fff;

  img {
    height: 30px;
    margin: 12px 15px;
  }

  p {
    margin: 12px 15px 12px 0;
    text-align: start;
  }
}
</style>


